module.exports = __webpack_public_path__ + "@/assets/img/mail-locked.af45466f.svg";